import type { FeeProfile } from './types';

export function determineSizeTier(
  profile: FeeProfile,
  weight: number,
  length: number,
  width: number,
  height: number
): string {
  const limits = profile.sizeTierLimits;
  const dims = [length, width, height].sort((a, b) => b - a);
  const longest = dims[0] ?? 0;
  const median = dims[1] ?? 0;
  const shortest = dims[2] ?? 0;
  const lengthPlusGirth = longest + 2 * (median + shortest);

  const s = limits.smallStandard;
  if (weight <= s.weight && longest <= s.longest && median <= s.median && shortest <= s.shortest) {
    return 'Small standard';
  }

  const l = limits.largeStandard;
  if (weight <= l.weight && longest <= l.longest && median <= l.median && shortest <= l.shortest) {
    return 'Large standard';
  }

  const b = limits.largeBulky;
  if (
    weight <= b.weight &&
    longest <= b.longest &&
    median <= b.median &&
    shortest <= b.shortest &&
    lengthPlusGirth <= b.lengthPlusGirth
  ) {
    return 'Large bulky';
  }

  if (weight <= 50) return 'Extra-large 0 to 50 lb';
  if (weight <= 70) return 'Extra-large 50+ to 70 lb';
  if (weight <= 150) return 'Extra-large 70+ to 150 lb';
  return 'Extra-large 150+ lb';
}
